'use client';

import { useCallback, useRef } from 'react';
import { useUnit } from 'effector-react';
import { planName, PlanType } from '@lib/billing-plan-name';
import { $ModalStore } from '@nx-frontend/shared/ui/modal';
import { axiosClient } from '@nx-frontend/shared/api';
import { FromCallEndPopupPayload, PopupType } from '@nx-frontend/shared/types';
import { GetOpenFromCallEndPopupProps } from '@nx-frontend/shared/types';

export const getOpenFromCallEndPopup = ({ openModal, payload }: GetOpenFromCallEndPopupProps) => {
  openModal({
    content: PopupType.FROM_CALL_END,
    showCloseButton: false,
    payload,
  });
};

export function FromCallEndPopup() {
  const [modalStore] = useUnit([$ModalStore]);

  let orgId = '';

  const modal = modalStore.find((m) => m.content === PopupType.FROM_CALL_END);

  if (modal && modal.payload && modal.payload.payloadType === PopupType.FROM_CALL_END) {
    const payload: FromCallEndPopupPayload = modal.payload;
    if (payload.orgId) {
      orgId = payload.orgId;
    }
  }

  const nimTrialWelcomeRef = useRef<HTMLDivElement>(null);

  const onChooseDateClick = useCallback(async () => {
    window.open('https://get-started.nimbusweb.me/', '_blank');
  }, []);

  const onFreeClick = useCallback(async () => {
    await axiosClient.post(`/v2/api/orgs/${orgId}/delete-trial`);
    window.location.reload();
  }, [orgId]);

  const showTrialEndPopup = () => (
    <div
      data-cy="from-call-welcome-popup"
      className="w-[1040px] min-w-[1040px] min-h-[493apx] relative nimbus-popup-content text-white"
      ref={nimTrialWelcomeRef}
    >
      <div className="ml-[48px] mt-[29px] mb-[40px] flex flex-col font-inter">
        <div className="flex">
          <div className="">
            <div className="basis-full w-full !text-[32px] mb-[12px] relative">
              <div className="z-[1] relative font-bold">Trial Complete, Journey Continues</div>
            </div>
            <div className="!text-[16px] mb-[16px]" style={{ fontWeight: 400 }}>
              Unlock your full potential and achieve more with <br />
              FuseBase {planName[PlanType.BUSINESS]} features:
            </div>
            <div className="text-base text-justify mb-[30px]" style={{ fontWeight: 400 }}>
              <div className="flex flex-row">
                <img
                  src="/assets/img/from-call-check.svg"
                  width={16}
                  height={16}
                  className="min-w-[16px] min-h-[16px] mr-[6px]"
                  alt=""
                />
                White-labeled Client Portals
              </div>
              <div className="flex flex-row">
                <img
                  src="/assets/img/from-call-check.svg"
                  width={16}
                  height={16}
                  className="min-w-[16px] min-h-[16px] mr-[6px]"
                  alt=""
                />
                Granular Permissions
              </div>
              <div className="flex flex-row">
                <img
                  src="/assets/img/from-call-check.svg"
                  width={16}
                  height={16}
                  className="min-w-[16px] min-h-[16px] mr-[6px]"
                  alt=""
                />
                AI-powered Copilots
              </div>
              <div className="flex flex-row">
                <img
                  src="/assets/img/from-call-check.svg"
                  width={16}
                  height={16}
                  className="min-w-[16px] min-h-[16px] mr-[6px]"
                  alt=""
                />
                Unlimited Client Accounts
              </div>
            </div>
            <div className="mt-[52px] mb-[24px]" style={{ fontWeight: 600 }}>
              Contact us at{' '}
              <a href="mailto:contact@thefusebase.com" className="text-[#96E1DC]">
                contact@thefusebase.com
              </a>{' '}
              or schedule <br />a meeting for a personalized quote and tailored solution
            </div>
            <div className="flex flex-row">
              <div className="w-[180px]">
                <button
                  className="flex items-center justify-center whitespace-nowrap font-bold select-none h-9 px-8 bg-[#96E1DC] hover:bg-[#96E1DC] active:bg-[#96E1DC] text-[#001216] rounded w-full h-[42px] !text-[16px]"
                  onClick={onChooseDateClick}
                  style={{ fontWeight: 700 }}
                >
                  Choose date
                </button>
              </div>
              <div className="w-[180px] ml-[24px]">
                <button
                  className="flex items-center justify-center whitespace-nowrap font-bold select-none h-9 px-8 bg-transparent border-[1px] border-cyan text-[#96E1DC] rounded w-full h-[42px] !text-[16px]"
                  onClick={onFreeClick}
                  style={{ fontWeight: 700, borderColor: '#96E1DC' }}
                >
                  Stay on free plan
                </button>
              </div>
            </div>
          </div>
          <div className="absolute bottom-[-60px] right-0">
            <img
              src="/assets/img/from-call-end.png"
              width={524}
              height={425}
              className="min-w-[524px] min-h-[425px]"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  );

  return showTrialEndPopup();
}
